import styled from 'styled-components';

export const ContentWrapper = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(4),
  padding: spacing([0, 8]),
  marginBottom: spacing(13.5),
}));
